import script from "./LlSecondaryButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LlSecondaryButton.vue?vue&type=script&setup=true&lang=js"

import "./LlSecondaryButton.vue?vue&type=style&index=0&id=53b9c09e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53b9c09e"]])

export default __exports__